export const cursor = {
  button: { value: 'pointer' },
};
